/** Success toasts sit bottom-left and clear fast, so they never cover the header's Next button. */
export const QUIET_TOAST = { position: 'bottom-left', duration: 2000 } as const;
